import { render } from "./Contact.vue?vue&type=template&id=b9d4d140&scoped=true"
import script from "../js/contact.js?vue&type=script&lang=js"
export * from "../js/contact.js?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=b9d4d140&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d4d140"]])

export default __exports__